import { useEffect, useRef, useState } from "react";
import throttle from "lodash.throttle";
import { useDispatch, useSelector } from "react-redux";
import { SECONDS_BEFORE_REST } from "../ducks/consts";
import { resetSelfcheckoutSession } from "../ducks/selfcheckoutSession";
import { selectLayout } from "../ducks/shopSelectors";

// Telas que não podem cair no descanso enquanto estão abertas (o cliente
// pagando na maquininha do TEF, por exemplo). Fica fora do Redux porque não é
// estado de tela: é só um "não agora" que o relógio consulta.
let holds = 0;

/**
 * Segura a tela de descanso enquanto `active` for verdadeiro. Ao soltar, o
 * relógio recomeça do zero: o cliente ganha os 3 minutos inteiros.
 */
export function useHoldRest(active) {
  useEffect(() => {
    if (!active) return;
    holds += 1;
    return () => {
      holds -= 1;
    };
  }, [active]);
}

export default function useResting() {
  // "controles" do modo de descanso, são efeitos colaterais muito delicados
  // que vagam praticamente por entre os detalhes de implementação do react,
  // estão com efeitos colaterais e limpezas bem definidos e otimizadas.
  const dispatch = useDispatch();
  const { uri, orderLocation, tableId } = useSelector((state) => state.shop);
  const useRestWall = useSelector(selectLayout).restWall;

  const [onRestMode, setOnRestMode] = useState(false);
  // 0 = ainda não começou a contar; o relógio parte quando o descanso liga
  const lastInteractionRef = useRef(0);

  useEffect(() => {
    if (!useRestWall) {
      return;
    }

    // mantém referência de última interação atualizada sem interferir
    // no ciclo de vida do react, exceto se for preciso DESATIVAR o modo de descanso.

    // const root = document.getElementById("root");
    const handleUserInteraction = throttle(() => {
      lastInteractionRef.current = Date.now();

      if (onRestMode) {
        console.log("Exiting rest mode, resuming.", new Date());
        setOnRestMode(false);
      }
    }, 500);

    const events = ["click", "touchmove", "wheel", "keyup"];

    events.forEach((event) =>
      document.addEventListener(event, handleUserInteraction, {
        passive: true,
      }),
    );
    return () => {
      events.forEach((event) =>
        document.removeEventListener(event, handleUserInteraction),
      );
    };
  }, [useRestWall, onRestMode]);

  useEffect(() => {
    if (!useRestWall) {
      return;
    }

    // lê frequentemente a última interação do usuário sem fazer nada,
    // exceto se precisar ATIVAR modo de descanso

    if (onRestMode) {
      return;
    }

    if (!lastInteractionRef.current) {
      lastInteractionRef.current = Date.now();
    }

    const interval = setInterval(() => {
      const now = Date.now();
      if (holds > 0) {
        lastInteractionRef.current = now;
        return;
      }

      const lastInteraction = lastInteractionRef.current;

      const diff = now - lastInteraction;

      const mustRest = diff >= SECONDS_BEFORE_REST * 1000;
      if (mustRest) {
        console.log("Reseting interaction, entering rest mode.", new Date());

        setOnRestMode(true);

        dispatch(resetSelfcheckoutSession());

        window.history.pushState(
          "home",
          "",
          `/${uri}/${orderLocation}/${tableId}`,
        );
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [dispatch, useRestWall, uri, orderLocation, tableId, onRestMode]);

  return {
    onRestMode,
  };
}
